export {VFileMessage} from './lib/index.js'
